module.exports = __webpack_public_path__ + "img/38.35620ac1.svg";